import { SignIn } from "@clerk/clerk-react";
import { useLocation } from "wouter";

const SignInPage = () => {
  const [location] = useLocation();
  // Determine the base path for Clerk's routing
  // If we are on /login or any sub-route of /login, use /login
  // Otherwise default to /sign-in
  const signInPath = location?.startsWith("/login") ? "/login" : "/sign-in";

  return (
    <div className="flex items-center justify-center min-h-screen bg-background font-sans">
      <SignIn
        path={signInPath}
        routing="path"
        signUpUrl="/sign-up"
        redirectUrl="/sign-in/sso-callback"
        afterSignInUrl="/dashboard"
        afterSignUpUrl="/onboarding/step-1"
        appearance={{
          elements: {
            formButtonPrimary:
              'bg-primary text-primary-foreground hover:bg-primary/90',
          },
        }}
      />
    </div>
  );
};

export default SignInPage;
